import { type ComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/comunicazioneDTO.ts';
import { useCurrentUser } from '@framework/auth/state/AuthSlice.tsx';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { useTheme } from 'styled-components';
import { CommunicationLogic } from '../logic/CommunicationLogic.ts';

export interface ICommunicationStateTagProps {
  communication: ComunicazioneDTO | null | undefined;
}

/**
 * Al momento lo stato indica solo se la comunicazione è ancora in bozza o se è stata inviata
 */
export function CommunicationStateTag(props: ICommunicationStateTagProps) {
  const { communication } = props;
  const theme = useTheme();
  const currentUser = useCurrentUser();

  const isDraft = CommunicationLogic.isDraft(communication);
  const isUserSender = CommunicationLogic.isUserSender(
    currentUser,
    communication,
  );

  if (!communication) return null;

  if (isDraft) {
    return <StyledTag>BOZZA</StyledTag>;
  }

  if (isUserSender) {
    return <StyledTag color={theme['blue-6']}>INVIATA</StyledTag>;
  }

  return <StyledTag color={theme.colorSuccess}>RICEVUTA</StyledTag>;
}
